export default __webpack_public_path__ + "static/image1-a8bb15cf6f3f97df532a128e3df15f9c.png";